<mat-card style="border-color: #5775a8;">

  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="flex flex-row rounded-lg w-full" style="background-color: #5775a8;align-items: center;">
      <div class="flex w-full" style="padding: 15px;">
        <span style="color: white;">
          Exempt Businesses
        </span>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <br />
    <mat-card>
      <div class="flex flex-col">
        <div class="flex flex-row">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100" #TableSort="matSort"
            class="mat-elevation-z8">

            <ng-container matColumnDef="businessName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Name</th>
              <td mat-cell *matCellDef="let business" style="align-items: center; text-align: center;">
                <a (click)="gotoBusiness(business.id)">{{business.businessName}}</a>
              </td>
            </ng-container>
            <ng-container matColumnDef="businessAddress1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
              <td mat-cell *matCellDef="let business">
                <span style="font-size: small;">
                  {{business.businessAddress1}}
                  <br />
                  {{business.businessCity}} {{business.businessZip}}
                  <br />
                  {{business.countyName}} County
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="exemptType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Certification Type</th>
              <td mat-cell *matCellDef="let business">
                {{business.exemptType}}
              </td>
            </ng-container>
            <ng-container matColumnDef="exemptCertificateDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Certification Date</th>
              <td mat-cell *matCellDef="let business">
                {{business.exemptCertificateDate}}
              </td>
            </ng-container>
            <ng-container matColumnDef="exemptStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Exempt Status</th>
              <td mat-cell *matCellDef="let business">
                {{business.exemptStatus}}
              </td>
            </ng-container>
            <ng-container matColumnDef="active">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Status</th>
              <td mat-cell *matCellDef="let business">
                <span *ngIf="business.active" style="color:green;">Active</span>
                <span *ngIf="!business.active" style="color:red;">Inactive</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>
          </table>

        </div>
        <div style="padding-right: 20px;">
          <button mat-raised-button (click)="return()">
            Return
          </button>
        </div>

      </div>
    </mat-card>
    <br />

  </mat-card-content>

</mat-card>



